export default __webpack_public_path__ + "static/2389-9a43f8aabf53cfbb3170e93760d8464a.gif";